import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementSummary.Save.IRequest;
type Response = Api.Core.StatementSummary.Save.IResponse;
type Headers = Api.Core.StatementSummary.Save.IHeaders;
const url = '/api/DealerManagement/StatementSummary';
export default async function statementSummarySaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
